import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class OrganizationFavoriteGroupsService extends AbstractService {
	static organizationFavoriteGroupsApi = NexusService.organizationFavoriteGroupsApi;

	static getGroups() {
		return this.organizationFavoriteGroupsApi
			.getOrganizationFavoriteGroups()
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
	}

	static saveGroup({ name, id }) {
		if (id !== null && id !== undefined) {
			const updateReq = {
				id,
				organizationFavoriteGroupUpdatePayload: {
					Name: name,
				},
			};
			return this.organizationFavoriteGroupsApi
				.updateOrganizationFavoriteGroup(updateReq)
				.then(response => ({ data: response }));
		}

		const saveReq = {
			organizationFavoriteGroupCreatePayload: {
				Name: name,
			},
		};

		return this.organizationFavoriteGroupsApi
			.createOrganizationFavoriteGroup(saveReq)
			.then(response => ({ data: response }));
	}

	static migrateGroup({ id, destinationGroupId }) {
		const migrateReq = {
			id,
			favoriteGroupMigratePayload: {
				DestinationGroupId: destinationGroupId,
			},
		};
		return this.organizationFavoriteGroupsApi
			.migrateOrganizationFavoriteGroup(migrateReq)
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
	}

	static deleteGroup(id) {
		const deleteReq = {
			id,
		};
		return this.organizationFavoriteGroupsApi
			.deleteOrganizationFavoriteGroup(deleteReq)
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
	}
}
